import { Typography, Box } from "@mui/material";
import NumberFormats from "components/NumberFormats";
import { DefaultUrlWeb } from "config/Configuration";

export default function WrapperAmount({ data }) {
  return (
    <Box display="flex" alignItems="center">
      <img src={DefaultUrlWeb + data?.coinImageUrl} alt="" width={25} />
      <Typography variant="h5" color="text.main" px={1}>
        <NumberFormats value={data?.amount} />
      </Typography>
      <Typography variant="h5" color="text.main">
        {data?.coinName}
      </Typography>
    </Box>
  );
}
